import { localeFromLang, type Language } from "./Lang";

const FRACTION_DIGITS = { minimumFractionDigits: 2, maximumFractionDigits: 2 } as const;

export function formatPriceEuro(value: number, lang: Language): string {
    return `${Number(value).toLocaleString(localeFromLang(lang, "number"), FRACTION_DIGITS)}€`;
}

/** Signed wallet ledger amount (e.g. +12,00€ / -5,00€). */
export function formatSignedPriceEuro(amount: number, lang: Language): string {
    const formatted = formatPriceEuro(Math.abs(amount), lang);
    if (amount > 0) return `+${formatted}`;
    if (amount < 0) return `-${formatted}`;
    return formatted;
}
